import { reatomAsync, withDataAtom } from "@reatom/async";
import { ChangeUserData } from "definitions/poizon-sso";
import { API } from "src/api";

export const finalyRegistrationRequest = reatomAsync(
  (ctx, data: ChangeUserData) => {
    return API.userApi.userControllerChangeMe(data);
  },
).pipe(withDataAtom(null));
